export default "__VITE_ASSET__C5JCWB0P__"